import React from 'react';

const WelcomeBanner = () => {
  const bannerStyles = {
    container: {
      background: 'linear-gradient(135deg, #1c1544 0%, #d9b36c 100%)',
      padding: '30px',
      borderRadius: '15px',
      color: 'white',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      overflow: 'hidden'
    },
    header: {
      textAlign: 'center',
      marginBottom: '25px'
    },
    title: {
      fontSize: '2.2em',
      fontWeight: '300',
      marginBottom: '15px',
      color: 'white'
    },
    subtitle: {
      fontSize: '1em',
      lineHeight: '1.5',
      color: 'rgba(255, 255, 255, 0.9)',
      marginBottom: '0'
    },
    contactsSection: {
      marginBottom: '25px'
    },
    sectionTitle: {
      fontSize: '1.2em',
      fontWeight: '600',
      marginBottom: '15px',
      textAlign: 'center',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    },
    contactItem: {
      background: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(10px)',
      padding: '12px 15px',
      borderRadius: '8px',
      marginBottom: '10px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      transition: 'all 0.3s ease'
    },
    contactTitle: {
      fontWeight: '600',
      fontSize: '0.9em',
      marginBottom: '5px',
      color: 'white'
    },
    contactPerson: {
      color: '#FFE082',
      fontWeight: '500',
      fontSize: '0.85em'
    },
    contactEmail: {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: '0.75em',
      marginTop: '3px'
    },
    firstAccess: {
      background: 'rgba(255, 243, 205, 0.2)',
      border: '1px solid rgba(255, 243, 205, 0.3)',
      borderRadius: '8px',
      padding: '15px',
      marginTop: '20px'
    },
    firstAccessTitle: {
      color: '#FFE082',
      fontWeight: '600',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      fontSize: '0.95em'
    },
    firstAccessText: {
      color: 'rgba(255, 255, 255, 0.9)',
      fontSize: '0.85em',
      lineHeight: '1.4',
      marginBottom: '10px'
    },
    shortcutContainer: {
      textAlign: 'center',
      marginTop: '10px'
    },
    shortcutKey: {
      background: 'rgba(44, 62, 80, 0.8)',
      color: '#ecf0f1',
      padding: '5px 10px',
      borderRadius: '15px',
      fontFamily: 'Courier New, monospace',
      fontWeight: 'bold',
      fontSize: '0.8em',
      margin: '3px',
      display: 'inline-block',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    },
    icon: {
      fontSize: '1.8em',
      marginBottom: '10px'
    }
  };

  return (
    <div style={bannerStyles.container}>
      <div style={bannerStyles.header}>
        <div style={bannerStyles.icon}>💼</div>
        <h4 style={bannerStyles.title}>Seja bem-vindo, a nova ferramenta de Orçamento! </h4>
        <p style={bannerStyles.subtitle}>
          Estamos em constante evolução e, para acompanhar esse movimento, 
          apresentamos uma interface totalmente renovada, mais moderna e intuitiva.
        </p>
      </div>

      <div style={bannerStyles.contactsSection}>
        <h2 style={bannerStyles.sectionTitle}>
          📞 Para caso de dúvidas, entre em contato
        </h2>
        
        <div style={bannerStyles.contactItem}>
          <div style={bannerStyles.contactTitle}>Suporte Geral</div>
          <div style={bannerStyles.contactPerson}>Solange Nallin (Financeira) - Ramal 1020</div>
          <div style={bannerStyles.contactEmail}>snallin@santacruzbr.com.br</div>
        </div>

        <div style={bannerStyles.contactItem}>
          <div style={bannerStyles.contactTitle}>Suporte Gerencial</div>
          <div style={bannerStyles.contactPerson}>Peterson Andreasi (Controller) - Ramal 1011</div>
          <div style={bannerStyles.contactEmail}>pandreasi@santacruzbr.com.br</div>
        </div>

      </div>

      <div style={bannerStyles.firstAccess}>
        <h3 style={bannerStyles.firstAccessTitle}>
          ⚠️ Primeiro Acesso
        </h3>
        <p style={bannerStyles.firstAccessText}>
          Para o primeiro acesso, limpar o cache do navegador na página em que o Orçamento está sendo aberto.
        </p>
        <div style={bannerStyles.shortcutContainer}>
          <span style={bannerStyles.shortcutKey}>Ctrl + F5</span>
          <span style={{color: '#1c1544', margin: '0 8px', fontSize: '0.85em'}}>ou</span>
          <span style={bannerStyles.shortcutKey}>Ctrl + Fn + F5</span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;